;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { NotificationsGlyph } from "./glyphs"

/**
 * Rendered at 18px in rgba(0,0,0,0.6) — the effective size/color the old MUI
 * Menu styles applied to icons without explicit sizing.
 */
export default function NotificationsIcon() {
  return <NotificationsGlyph size={18} style={{ color: "rgba(0, 0, 0, 0.6)" }} />
}
